import { Component, Inject, EventEmitter } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";

@Component({
    template: `
    <h1 mat-dialog-title [innerHTML]="this.title">Statement</h1>
    <div mat-dialog-content [innerHTML]="this.html"> 
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)='doClose()'  tabindex="2">Cancel</button>
      <button mat-button (click)='doConfirm()'  tabindex="2">Yes</button>
    </div>
    `
  })
  export class ConfirmDialogComponent {
    html: string;
    title: string;
    constructor(
      public dialogRef: MatDialogRef<ConfirmDialogComponent >,
      @Inject(MAT_DIALOG_DATA) public data: any) { }
  
    private confirm:EventEmitter<boolean> = new EventEmitter<boolean>();
  
    doClose(): void {
      this.dialogRef.close();
      this.confirm.emit(false);
    }
  
    doConfirm(): void {
      this.dialogRef.close();
      this.confirm.emit(true);
    }
  
  }
  
  
  


// WEBPACK FOOTER //
// ./src/app/shared/components/dialog/confirm-dialog.component.ts